webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_dialogLogin_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogHelp_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogLegal_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogAddPoint_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dataSnowmakingHydrants_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dataLiftmaintenanceCables_vue__ = __webpack_require__(35);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      drawer: false
    };
  },

  computed: {
    toggle_imagry_summer2014_state: {
      get: function get() {
        return this.$store.state.toggle.imagry.summer_2014_40cm;
      },
      set: function set() {
        this.toggle_imagry_summer2014();
      }
    },
    general_title_state: {
      get: function get() {
        return this.$store.state.general.title;
      }
    },
    toggle_add_point_state: {
      get: function get() {
        return this.$store.state.toggle.add.point;
      },
      set: function set() {
        this.toggle_add_point();
      }
    },
    toggle_data_snowmaking_hydrants_state: {
      get: function get() {
        return this.$store.state.toggle.data.snowmaking.hydrants;
      },
      set: function set() {
        this.toggle_data_snowmaking_hydrants();
      }
    },
    toggle_data_liftmaintenance_cables_state: {
      get: function get() {
        return this.$store.state.toggle.data.liftmaintenance.cables;
      },
      set: function set() {
        this.toggle_data_liftmaintenance_cables();
      }
    },
    computedDeptData: {
      get: function get() {
        return this.$store.state.layers;
      }
    }
  },
  methods: {
    methodDialogUi: function methodDialogUi(dialog) {
      this.$store.commit('mutationDialogUi', {
        dialog: dialog
      });
    },
    toggle_imagry_summer2014: function toggle_imagry_summer2014() {
      this.$store.commit('toggleSummer2014');
    },
    toggle_dialog_help: function toggle_dialog_help() {
      this.$store.commit('toggleDialogHelp');
    },
    toggle_dialog_legal: function toggle_dialog_legal() {
      this.$store.commit('toggleDialogLegal');
    },
    toggle_dialog_login: function toggle_dialog_login() {
      this.$store.commit('toggleDialogLogin');
    },
    toggle_dialog_add_point: function toggle_dialog_add_point() {
      this.$store.commit('toggleDialogAddPoint');
    },
    toggle_data_snowmaking_hydrants: function toggle_data_snowmaking_hydrants() {
      this.$store.commit('toggleDataSnowmakingHydrants');
    },
    toggle_data_liftmaintenance_cables: function toggle_data_liftmaintenance_cables() {
      this.$store.commit('toggleDataLiftmaintenanceCables');
    },
    toggleMapLayer: function toggleMapLayer(dept, layer) {
      this.$store.commit('mutationMapLayer', {
        dept: dept,
        layer: layer
      });
    },
    toggleListLayer: function toggleListLayer(dept, layer) {
      this.$store.commit('mutationListLayer', {
        dept: dept,
        layer: layer
      });
    }
  },
  components: {
    'dialog-login': __WEBPACK_IMPORTED_MODULE_0__components_dialogLogin_vue__["a" /* default */],
    'dialog-help': __WEBPACK_IMPORTED_MODULE_1__components_dialogHelp_vue__["a" /* default */],
    'dialog-legal': __WEBPACK_IMPORTED_MODULE_2__components_dialogLegal_vue__["a" /* default */],
    'dialog-add-point': __WEBPACK_IMPORTED_MODULE_3__components_dialogAddPoint_vue__["a" /* default */],
    'data-snowmaking-hydrants': __WEBPACK_IMPORTED_MODULE_4__components_dataSnowmakingHydrants_vue__["a" /* default */],
    'data-liftmaintenance-cables': __WEBPACK_IMPORTED_MODULE_5__components_dataLiftmaintenanceCables_vue__["a" /* default */]
  },
  name: 'App'
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    computedDialogUiLogin: function computedDialogUiLogin() {
      return this.$store.state.dialogs.ui.dialogLogin;
    }
  },
  methods: {
    methodDialogUi: function methodDialogUi(dialog) {
      this.$store.commit('mutationDialogUi', {
        dialog: dialog
      });
    }
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    computedDialogUiHelp: function computedDialogUiHelp() {
      return this.$store.state.dialogs.ui.dialogHelp;
    }
  },
  methods: {
    methodDialogUi: function methodDialogUi(dialog) {
      this.$store.commit('mutationDialogUi', {
        dialog: dialog
      });
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    computedDialogUiLegal: function computedDialogUiLegal() {
      return this.$store.state.dialogs.ui.dialogLegal;
    },
    computedTitle: function computedTitle() {
      return this.$store.state.general.title;
    },
    computedCopyrightNotice: function computedCopyrightNotice() {
      return this.$store.state.general.copyrightNotice;
    },
    computedCopyrightData: function computedCopyrightData() {
      return this.$store.state.general.copyrightData;
    }
  },
  methods: {
    methodDialogUi: function methodDialogUi(dialog) {
      this.$store.commit('mutationDialogUi', {
        dialog: dialog
      });
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      layers: ['Hydrants', 'Image', 'Sign Structure']
    };
  },

  computed: {
    toggle_dialog_add_point_state: {
      get: function get() {
        return this.$store.state.toggle.dialog.add.point;
      },
      set: function set() {
        this.toggle_dialog_add_point();
      }
    }
  },
  methods: {
    toggle_dialog_add_point: function toggle_dialog_add_point() {
      this.$store.commit('toggleDialogAddPoint');
    }
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search: '',
      rows_per_page: [10, 25, 50, { 'text': 'All',
        'value': -1
      }],
      rows_per_page_text: 'Per page:',
      headers: [{
        text: 'Hydrant #',
        value: 'properties.hydrnt_num'
      }, {
        text: 'id',
        value: 'properties.id'
      }, {
        text: '30A',
        value: 'properties.amp30'
      }, {
        text: '60A',
        value: 'properties.amp60'
      }, {
        text: 'Water',
        value: 'properties.water'
      }, {
        text: 'Air',
        value: 'properties.air'
      }]
    };
  },

  computed: {
    computedLiftMaintenanceCablesGeoJsonFeatures: function computedLiftMaintenanceCablesGeoJsonFeatures() {
      return this.$store.state.layers.snowmaking.mapLayers.hydrants.geojson.features;
    },

    toggle_data_snowmaking_hydrants_state: {
      get: function get() {
        return this.$store.state.layers.snowmaking.mapLayers.hydrants.visibility.listView;
      },
      set: function set() {
        this.toggle_data_snowmaking_hydrants();
      }
    }
  },
  methods: {
    toggleSnowmakingHydrantsListView: function toggleSnowmakingHydrantsListView() {
      this.$store.commit('mutationListLayer', {
        dept: 'snowmaking',
        layer: 'hydrants'
      });
    }
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search: '',
      rows_per_page: [10, 25, 50, { 'text': 'All',
        'value': -1
      }],
      rows_per_page_text: 'Per page:',
      headers: [{
        text: 'Lift Name',
        value: 'properties.lift_name'
      }, {
        text: 'Cable Direction',
        value: 'properties.cable_dir'
      }, {
        text: 'Manufacturer',
        value: 'properties.manufacturer'
      }, {
        text: 'Type',
        value: 'properties.type'
      }, {
        text: '# of Towers',
        value: 'properties.num_twrs'
      }, {
        text: '# of Carriers',
        value: 'properties.num_carriers'
      }]
    };
  },

  computed: {
    computedLiftMaintenanceCablesGeoJsonFeatures: function computedLiftMaintenanceCablesGeoJsonFeatures() {
      return this.$store.state.layers.liftmaintenance.mapLayers.cables.geojson.features;
    },

    toggle_data_liftmaintenance_cables_state: {
      get: function get() {
        return this.$store.state.layers.liftmaintenance.mapLayers.cables.visibility.listView;
      },
      set: function set() {
        this.toggleLiftmaintenanceCablesListView();
      }
    }
  },
  methods: {
    toggleLiftmaintenanceCablesListView: function toggleLiftmaintenanceCablesListView() {
      this.$store.commit('mutationListLayer', {
        dept: 'liftmaintenance',
        layer: 'cables'
      });
    }
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionButton_vue__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_imagry_satSummer2014__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_layers_snowmakingHydrants__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_layers_liftmaintenanceCables__ = __webpack_require__(48);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_imagry_satSummer2014__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_layers_snowmakingHydrants__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_layers_liftmaintenanceCables__["a" /* default */]],
  components: {
    'action-button': __WEBPACK_IMPORTED_MODULE_2__actionButton_vue__["a" /* default */]
  },
  methods: {
    mapInitialized: function mapInitialized(map) {
      this.map = map;
    },
    mapLoaded: function mapLoaded(map) {
      // If default is set to true, make visible
      if (this.$store.state.toggle.imagry.summer_2014_40cm) {
        this.mapLayerSatSummer2014Add();
      }
      if (this.computedSnowmakingHydrantsMapVisibility) {
        this.mapLayerSnowmakingHydrantsAdd();
      }
      if (this.computedLiftmaintenanceCablesMapVisibility) {
        this.mapLayerLiftmaintenanceCablesAdd();
      }
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      fab: false
    };
  },

  methods: {
    toggle_dialog_add_point: function toggle_dialog_add_point() {
      this.$store.commit('toggleDialogAddPoint');
    }
  }
});

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mapbox_gl_dist_mapbox_gl_css__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mapbox_gl_dist_mapbox_gl_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mapbox_gl_dist_mapbox_gl_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mapbox_gl_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mapbox_gl_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mapbox_gl_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_index__ = __webpack_require__(55);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Mapbox', __WEBPACK_IMPORTED_MODULE_7_mapbox_gl_vue___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuetify___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_8__store_index__["a" /* store */],
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  template: '<App/>'
});

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(7);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1a21060_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(37);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1a21060_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialogLogin_vue__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1a7fb4c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dialogLogin_vue__ = __webpack_require__(26);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialogLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1a7fb4c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dialogLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.computedDialogUiLogin),callback:function ($$v) {_vm.computedDialogUiLogin=$$v},expression:"computedDialogUiLogin"}},[_c('v-card',{staticClass:"elevation-12"},[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.methodDialogUi('dialogLogin')}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Login")])],1),_vm._v(" "),_c('v-card-text',[_c('v-form',[_c('v-text-field',{attrs:{"prepend-icon":"person","name":"login","label":"Login","type":"text"}}),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-icon":"lock","name":"password","label":"Password","id":"password","type":"password"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"}},[_vm._v("Login")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialogHelp_vue__ = __webpack_require__(9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46365201_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dialogHelp_vue__ = __webpack_require__(28);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialogHelp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46365201_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dialogHelp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.computedDialogUiHelp),callback:function ($$v) {_vm.computedDialogUiHelp=$$v},expression:"computedDialogUiHelp"}},[_c('v-card',{attrs:{"tile":"","three-line":""}},[_c('v-toolbar',{attrs:{"card":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.methodDialogUi('dialogHelp')}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Help")])],1),_vm._v(" "),_c('v-card-text',[_c('v-list',{attrs:{"three-line":"","subheader":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Logging in/User permissions")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("If you have any issues logging in or with user permissions, please contact Heather Dufty or Mike Hamilton.")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Using GeoWB")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Please contact Heather Dufty.")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Submit a bug report")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Please describe in detail what you were doing, what happened and what the expected outcome was. ")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialogLegal_vue__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fdc38fa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dialogLegal_vue__ = __webpack_require__(30);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialogLegal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fdc38fa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dialogLegal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.computedDialogUiLegal),callback:function ($$v) {_vm.computedDialogUiLegal=$$v},expression:"computedDialogUiLegal"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.methodDialogUi('dialogLegal')}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("About/Legal")])],1),_vm._v(" "),_c('v-card-text',[_c('v-list',{attrs:{"three-line":"","subheader":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Copyright Notice")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.computedCopyrightNotice))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.computedCopyrightData))])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("About GeoWB")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.computedTitle)+" was created in Whistler by Alchemy Mapping Solutions, Inc.")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialogAddPoint_vue__ = __webpack_require__(11);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376e4326_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dialogAddPoint_vue__ = __webpack_require__(32);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialogAddPoint_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376e4326_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dialogAddPoint_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.toggle_dialog_add_point_state),callback:function ($$v) {_vm.toggle_dialog_add_point_state=$$v},expression:"toggle_dialog_add_point_state"}},[_c('v-card',{staticClass:"elevation-12"},[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){return _vm.toggle_dialog_add_point($event)}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Add point")])],1),_vm._v(" "),_c('v-card-text',[_c('v-select',{attrs:{"items":_vm.layers,"label":"Select layer","single-line":"","auto":"","prepend-icon":"storage","hide-details":""}}),_vm._v(" "),_c('v-form',[_c('v-text-field',{attrs:{"prepend-icon":"place","name":"login","label":"Lat","id":"lat","type":"text"}}),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-icon":"place","name":"password","label":"Long","id":"lon","type":"text"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary"}},[_vm._v("Get Current Location")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"}},[_vm._v("Submit")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dataSnowmakingHydrants_vue__ = __webpack_require__(12);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_445c41ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dataSnowmakingHydrants_vue__ = __webpack_require__(34);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dataSnowmakingHydrants_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_445c41ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dataSnowmakingHydrants_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.toggle_data_snowmaking_hydrants_state),callback:function ($$v) {_vm.toggle_data_snowmaking_hydrants_state=$$v},expression:"toggle_data_snowmaking_hydrants_state"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.toggleSnowmakingHydrantsListView()}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Hydrants")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","single-line":"","hide-details":"","placeholder":"Filter hydrant data"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.computedLiftMaintenanceCablesGeoJsonFeatures,"rows-per-page-items":_vm.rows_per_page,"rows-per-page-text":_vm.rows_per_page_text,"search":_vm.search},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{on:{"click":function($event){props.expanded = !props.expanded}}},[_c('td',[_vm._v(_vm._s(props.item.properties.hydrnt_num))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.properties.id)+"\n            ")]),_c('td',[_vm._v(_vm._s(props.item.properties.amp30))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.properties.amp60))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.properties.water))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.properties.air))])])]}},{key:"expand",fn:function(props){return [_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_vm._v("Peek-a-boo!")])],1)]}}])},[_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n          Your search for \""+_vm._s(_vm.search)+"\" found no results.\n        ")])],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dataLiftmaintenanceCables_vue__ = __webpack_require__(13);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ee2b03a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dataLiftmaintenanceCables_vue__ = __webpack_require__(36);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dataLiftmaintenanceCables_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ee2b03a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dataLiftmaintenanceCables_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.toggle_data_liftmaintenance_cables_state),callback:function ($$v) {_vm.toggle_data_liftmaintenance_cables_state=$$v},expression:"toggle_data_liftmaintenance_cables_state"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.toggleLiftmaintenanceCablesListView()}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Lift Cables")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","single-line":"","hide-details":"","placeholder":"Filter lift cable data"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.computedLiftMaintenanceCablesGeoJsonFeatures,"rows-per-page-items":_vm.rows_per_page,"rows-per-page-text":_vm.rows_per_page_text,"search":_vm.search},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.properties.lift_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.properties.cable_dir)+"\n          ")]),_c('td',[_vm._v(_vm._s(props.item.properties.manufacturer))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.properties.type))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.properties.num_twrs))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.properties.num_carriers))])]}}])},[_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n          Your search for \""+_vm._s(_vm.search)+"\" found no results.\n        ")])],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":""}},[_c('dialog-legal'),_vm._v(" "),_c('dialog-help'),_vm._v(" "),_c('dialog-login'),_vm._v(" "),_c('dialog-add-point'),_vm._v(" "),_c('data-snowmaking-hydrants'),_vm._v(" "),_c('data-liftmaintenance-cables'),_vm._v(" "),_c('v-navigation-drawer',{attrs:{"temporary":"","enable-resize-watcher":"","fixed":"","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',[_c('v-list-group',[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Satellite Imagry")])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":_vm.toggle_imagry_summer2014}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Summer 2014 (40cm resolution)")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-switch',{model:{value:(_vm.toggle_imagry_summer2014_state),callback:function ($$v) {_vm.toggle_imagry_summer2014_state=$$v},expression:"toggle_imagry_summer2014_state"}})],1)],1)],1),_vm._v(" "),_vm._l((_vm.computedDeptData),function(dept){return _c('v-list-group',{key:dept.id},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(dept.deptTitle))])],1)],1),_vm._v(" "),_vm._l((dept.mapLayers),function(layer){return _c('v-list-tile',{key:layer.id,on:{"click":function($event){_vm.toggleMapLayer(dept.name, layer.name)}},model:{value:(layer.visibility.mapView),callback:function ($$v) {_vm.$set(layer.visibility, "mapView", $$v)},expression:"layer.visibility.mapView"}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(layer.layerTitle))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"icon":""},on:{"click":[function($event){_vm.toggleListLayer(dept.name, layer.name)},function($event){$event.stopPropagation();}]}},[_c('v-icon',[_vm._v("list")])],1)],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-switch',{on:{"click":[function($event){_vm.toggleMapLayer(dept.name, layer.name)},function($event){$event.stopPropagation();}]},model:{value:(layer.visibility.mapView),callback:function ($$v) {_vm.$set(layer.visibility, "mapView", $$v)},expression:"layer.visibility.mapView"}})],1)],1)})],2)})],2)],1),_vm._v(" "),_c('v-toolbar',{attrs:{"app":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.general_title_state))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.methodDialogUi('dialogLogin')}}},[_c('v-list-tile-title',[_vm._v("Log In")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":_vm.toggle_data_snowmaking_hydrants}},[_c('v-list-tile-title',[_vm._v("Change Password")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.methodDialogUi('dialogHelp')}}},[_c('v-list-tile-title',[_vm._v("Help")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.methodDialogUi('dialogLegal')}}},[_c('v-list-tile-title',[_vm._v("About/Legal")])],1)],1)],1)],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mapComponent__ = __webpack_require__(40);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'mapComponent',
    component: __WEBPACK_IMPORTED_MODULE_2__components_mapComponent__["a" /* default */]
  }]
}));

/***/ }),
/* 39 */,
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mapComponent_vue__ = __webpack_require__(14);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0f1d1c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mapComponent_vue__ = __webpack_require__(49);
function injectStyle (ssrContext) {
  __webpack_require__(41)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e0f1d1c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mapComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0f1d1c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mapComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 42 */,
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_actionButton_vue__ = __webpack_require__(15);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed0e1d78_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_actionButton_vue__ = __webpack_require__(45);
function injectStyle (ssrContext) {
  __webpack_require__(44)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ed0e1d78"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_actionButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed0e1d78_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_actionButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 44 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"fab"}},[_c('v-speed-dial',{attrs:{"fixed":"","bottom":"","right":"","direction":"top","transition":"slide-y-reverse-transition"},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-btn',{attrs:{"slot":"activator","color":"red","dark":"","fab":"","hover":""},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v("add_location")]),_vm._v(" "),_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","dark":"","small":"","color":"green"}},[_c('v-icon',[_vm._v("panorama_horizontal")])],1),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","dark":"","small":"","color":"indigo"}},[_c('v-icon',[_vm._v("timeline")])],1),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","dark":"","small":"","color":"red"},on:{"click":_vm.toggle_dialog_add_point}},[_c('v-icon',[_vm._v("place")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    mapLayerSatSummer2014Add: function mapLayerSatSummer2014Add() {
      this.map.addSource('sat-2014-40cm-tiles', {
        type: 'raster',
        tiles: ['https://d1dsfrg9q75324.cloudfront.net/{z}/{x}/{y}.png'],
        tileSize: 256
      });

      this.map.addLayer({
        id: 'sat-2014-40cm-tiles',
        type: 'raster',
        source: 'sat-2014-40cm-tiles',
        layout: {
          visibility: 'visible'
        }
      });

      this.map.moveLayer('sat-2014-40cm-tiles', 'marker-layer-bottom');
    },
    mapLayerSatSummer2014Remove: function mapLayerSatSummer2014Remove() {
      this.map.removeLayer('sat-2014-40cm-tiles');
      this.map.removeSource('sat-2014-40cm-tiles');
    }
  },
  watch: {
    '$store.state.toggle.imagry.summer_2014_40cm': function $storeStateToggleImagrySummer_2014_40cm(newValue, oldValue) {
      if (newValue === true) {
        this.mapLayerSatSummer2014Add();
      } else {
        this.mapLayerSatSummer2014Remove();
      }
    }
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    mapLayerSnowmakingHydrantsAdd: function mapLayerSnowmakingHydrantsAdd() {
      this.initPollSnowmakingHydrants();
      this.map.addSource('hydrants', {
        type: 'geojson',
        data: this.computedSnowmakingHydrantsGeoJson,
        cluster: true,
        clusterMaxZoom: 13,
        clusterRadius: 40
      });

      this.map.addLayer({
        id: 'clusters',
        type: 'circle',
        source: 'hydrants',
        filter: ['has', 'point_count'],
        paint: {
          'circle-color': ['step', ['get', 'point_count'], '#51bbd6', 100, '#f1f075', 750, '#f28cb1'],
          'circle-radius': ['step', ['get', 'point_count'], 20, 100, 30, 750, 40]
        },
        layout: {
          visibility: 'visible'
        }
      });

      this.map.addLayer({
        id: 'cluster-count',
        type: 'symbol',
        source: 'hydrants',
        filter: ['has', 'point_count'],
        layout: {
          'text-field': '{point_count_abbreviated}',
          'text-font': ['Open Sans Semibold'],
          'text-size': 14,
          'visibility': 'visible'
        }
      });

      this.map.addLayer({
        filter: ['==', 'c_colour', 'Grey'],
        id: 'hydrants-grey',
        type: 'circle',
        source: 'hydrants',
        paint: {
          'circle-radius': 4,
          'circle-color': 'Grey',
          'circle-stroke-width': 1,
          'circle-stroke-color': 'Black'
        },
        layout: {
          visibility: 'visible'
        }
      });

      // HYDRANTS Black
      this.map.addLayer({
        filter: ['==', 'c_colour', 'Black'],
        id: 'hydrants-black',
        type: 'circle',
        source: 'hydrants',
        paint: {
          'circle-radius': 4,
          'circle-color': 'Black',
          'circle-stroke-width': 1,
          'circle-stroke-color': 'Black'
        },
        layout: {
          visibility: 'visible'
        }
      });

      // HYDRANTS White
      this.map.addLayer({
        filter: ['==', 'c_colour', 'White'],
        id: 'hydrants-white',
        type: 'circle',
        source: 'hydrants',
        paint: {
          'circle-radius': 4,
          'circle-color': 'White',
          'circle-stroke-width': 1,
          'circle-stroke-color': 'Black'
        },
        layout: {
          visibility: 'visible'
        }
      });

      // HYDRANTS Purple
      this.map.addLayer({
        filter: ['==', 'c_colour', 'Purple'],
        id: 'hydrants-purple',
        type: 'circle',
        source: 'hydrants',
        paint: {
          'circle-radius': 4,
          'circle-color': 'Purple',
          'circle-stroke-width': 1,
          'circle-stroke-color': 'Black'
        },
        layout: {
          visibility: 'visible'
        }
      });

      // HYDRANTS Blue
      this.map.addLayer({
        filter: ['==', 'c_colour', 'Blue'],
        id: 'hydrants-blue',
        type: 'circle',
        source: 'hydrants',
        paint: {
          'circle-radius': 4,
          'circle-color': 'Blue',
          'circle-stroke-width': 1,
          'circle-stroke-color': 'Black'
        },
        layout: {
          visibility: 'visible'
        }
      });

      // HYDRANTS Red
      this.map.addLayer({
        filter: ['==', 'c_colour', 'Red'],
        id: 'hydrants-red',
        type: 'circle',
        source: 'hydrants',
        paint: {
          'circle-radius': 4,
          'circle-color': 'Red',
          'circle-stroke-width': 1,
          'circle-stroke-color': 'Black'
        },
        layout: {
          visibility: 'visible'
        }
      });

      // HYDRANTS Green
      this.map.addLayer({
        filter: ['==', 'c_colour', 'Green'],
        id: 'hydrants-green',
        type: 'circle',
        source: 'hydrants',
        paint: {
          'circle-radius': 4,
          'circle-color': 'Green',
          'circle-stroke-width': 1,
          'circle-stroke-color': 'Black'
        },
        layout: {
          visibility: 'visible'
        }
      });

      // HYDRANTS None
      this.map.addLayer({
        filter: ['==', 'c_colour', 'None'],
        id: 'hydrants-none',
        type: 'circle',
        source: 'hydrants',
        paint: {
          'circle-radius': 4,
          'circle-color': 'White',
          'circle-stroke-width': 1,
          'circle-stroke-color': 'Black'
        },
        layout: {
          visibility: 'visible'
        }
      });

      // HYDRANTS Yellow
      this.map.addLayer({
        filter: ['==', 'c_colour', 'Yellow'],
        id: 'hydrants-yellow',
        type: 'circle',
        source: 'hydrants',
        paint: {
          'circle-radius': 4,
          'circle-color': 'Yellow',
          'circle-stroke-width': 1,
          'circle-stroke-color': 'Black'
        },
        layout: {
          visibility: 'visible'
        }
      });

      // HYDRANTS #49c6bc
      this.map.addLayer({
        filter: ['==', 'c_colour', '#49c6bc'],
        id: 'hydrants-49c6bc',
        type: 'circle',
        source: 'hydrants',
        paint: {
          'circle-radius': 4,
          'circle-color': '#49c6bc',
          'circle-stroke-width': 1,
          'circle-stroke-color': 'Black'
        },
        layout: {
          visibility: 'visible'
        }
      });

      // HYDRANTS Orange
      this.map.addLayer({
        filter: ['==', 'c_colour', 'Orange'],
        id: 'hydrants-orange',
        type: 'circle',
        source: 'hydrants',
        paint: {
          'circle-radius': 4,
          'circle-color': 'Orange',
          'circle-stroke-width': 1,
          'circle-stroke-color': 'Black'
        },
        layout: {
          visibility: 'visible'
        }
      });

      // RED LABELS
      this.map.addLayer({
        filter: ['==', 'h_colour', 'Red'],
        id: 'hydrants-label-red',
        type: 'symbol',
        source: 'hydrants',
        layout: {
          'text-field': '{hydrnt_num}',
          'text-anchor': 'left',
          'text-allow-overlap': true,
          'text-offset': [0.4, 0],
          'icon-allow-overlap': true,
          'text-font': ['Open Sans Semibold'],
          'visibility': 'visible'
        },
        paint: {
          'text-color': 'Red',
          'text-halo-color': '#fff',
          'text-halo-width': 2
        }
      });

      // GREEN LABELS
      this.map.addLayer({
        filter: ['==', 'h_colour', 'Green'],
        id: 'hydrants-label-green',
        type: 'symbol',
        source: 'hydrants',
        layout: {
          'text-field': '{hydrnt_num}',
          'text-anchor': 'left',
          'text-allow-overlap': true,
          'text-offset': [0.4, 0],
          'icon-allow-overlap': true,
          'text-font': ['Open Sans Semibold'],
          'visibility': 'visible'
        },
        paint: {
          'text-color': 'Green',
          'text-halo-color': '#fff',
          'text-halo-width': 2
        }
      });

      // PURPLE LABELS
      this.map.addLayer({
        'filter': ['==', 'h_colour', 'Purple'],
        'id': 'hydrants-label-purple',
        'type': 'symbol',
        'source': 'hydrants',
        'layout': {
          'text-field': '{hydrnt_num}',
          'text-anchor': 'left',
          'text-allow-overlap': true,
          'text-offset': [0.4, 0],
          'icon-allow-overlap': true,
          'text-font': ['Open Sans Semibold'],
          'visibility': 'visible'
        },
        'paint': {
          'text-color': 'Purple',
          'text-halo-color': '#fff',
          'text-halo-width': 2
        }
      });

      // BLUE LABELS
      this.map.addLayer({
        filter: ['==', 'h_colour', 'Blue'],
        id: 'hydrants-label-blue',
        type: 'symbol',
        source: 'hydrants',
        layout: {
          'text-field': '{hydrnt_num}',
          'text-anchor': 'left',
          'text-allow-overlap': true,
          'text-offset': [0.4, 0],
          'icon-allow-overlap': true,
          'text-font': ['Open Sans Semibold'],
          'visibility': 'visible'
        },
        paint: {
          'text-color': 'Blue',
          'text-halo-color': '#fff',
          'text-halo-width': 2
        }
      });

      // ORANGE LABELS
      this.map.addLayer({
        filter: ['==', 'h_colour', 'Orange'],
        id: 'hydrants-label-orange',
        type: 'symbol',
        source: 'hydrants',
        layout: {
          'text-field': '{hydrnt_num}',
          'text-anchor': 'left',
          'text-allow-overlap': true,
          'text-offset': [0.4, 0],
          'icon-allow-overlap': true,
          'text-font': ['Open Sans Semibold'],
          'visibility': 'visible'
        },
        paint: {
          'text-color': 'Orange',
          'text-halo-color': '#fff',
          'text-halo-width': 2
        }
      });

      // YELLOW LABELS
      this.map.addLayer({
        filter: ['==', 'h_colour', 'Yellow'],
        id: 'hydrants-label-yellow',
        type: 'symbol',
        source: 'hydrants',
        layout: {
          'text-field': '{hydrnt_num}',
          'text-anchor': 'left',
          'text-allow-overlap': true,
          'text-offset': [0.4, 0],
          'icon-allow-overlap': true,
          'text-font': ['Open Sans Semibold'],
          'visibility': 'visible'
        },
        paint: {
          'text-color': 'Yellow',
          'text-halo-color': '#fff',
          'text-halo-width': 2
        }
      });

      // WHITE LABELS
      this.map.addLayer({
        filter: ['==', 'h_colour', 'White'],
        id: 'hydrants-label-white',
        type: 'symbol',
        source: 'hydrants',
        layout: {
          'text-field': '{hydrnt_num}',
          'text-anchor': 'left',
          'text-allow-overlap': true,
          'text-offset': [0.4, 0],
          'icon-allow-overlap': true,
          'text-font': ['Open Sans Semibold'],
          'visibility': 'visible'
        },
        paint: {
          'text-color': 'White',
          'text-halo-color': 'Grey',
          'text-halo-width': 2
        }
      });
    },
    mapLayerSnowmakingHydrantsRemove: function mapLayerSnowmakingHydrantsRemove() {
      this.cancelPollSnowmakingHydrants();
      this.map.removeLayer('clusters');
      this.map.removeLayer('cluster-count');
      this.map.removeLayer('hydrants-grey');
      this.map.removeLayer('hydrants-black');
      this.map.removeLayer('hydrants-white');
      this.map.removeLayer('hydrants-purple');
      this.map.removeLayer('hydrants-blue');
      this.map.removeLayer('hydrants-red');
      this.map.removeLayer('hydrants-green');
      this.map.removeLayer('hydrants-none');
      this.map.removeLayer('hydrants-yellow');
      this.map.removeLayer('hydrants-orange');
      this.map.removeLayer('hydrants-49c6bc');
      this.map.removeLayer('hydrants-label-red');
      this.map.removeLayer('hydrants-label-green');
      this.map.removeLayer('hydrants-label-purple');
      this.map.removeLayer('hydrants-label-yellow');
      this.map.removeLayer('hydrants-label-blue');
      this.map.removeLayer('hydrants-label-orange');
      this.map.removeLayer('hydrants-label-white');
      this.map.removeSource('hydrants');
    },
    initPollSnowmakingHydrants: function initPollSnowmakingHydrants() {
      var _this = this;

      this.$store.dispatch('actionGetGeoJson', {
        url: '/static/hydrants.geojson',
        dept: 'snowmaking',
        layer: 'hydrants'
      });
      this.pollSnowmakingHydrantsInterval = setInterval(function () {
        _this.$store.dispatch('actionGetGeoJson', {
          url: '/static/hydrants.geojson',
          dept: 'snowmaking',
          layer: 'hydrants'
        });
      }, 10000);
    },
    cancelPollSnowmakingHydrants: function cancelPollSnowmakingHydrants() {
      this.pollSnowmakingHydrantsInterval = clearInterval(this.pollSnowmakingHydrantsInterval);
    }
  },
  computed: {
    computedSnowmakingHydrantsGeoJson: function computedSnowmakingHydrantsGeoJson() {
      return this.$store.state.layers.snowmaking.mapLayers.hydrants.geojson;
    },
    computedSnowmakingHydrantsMapVisibility: function computedSnowmakingHydrantsMapVisibility() {
      return this.$store.state.layers.snowmaking.mapLayers.hydrants.visibility.mapView;
    }
  },
  watch: {
    '$store.state.layers.snowmaking.mapLayers.hydrants.geojson': {
      handler: function handler(val, oldVal) {
        if (this.computedSnowmakingHydrantsMapVisibility) {
          this.mapLayerSnowmakingHydrantsRemove();
          this.mapLayerSnowmakingHydrantsAdd();
        }
      }
    },
    '$store.state.layers.snowmaking.mapLayers.hydrants.visibility.mapView': function $storeStateLayersSnowmakingMapLayersHydrantsVisibilityMapView(newValue, oldValue) {
      if (newValue) {
        this.mapLayerSnowmakingHydrantsAdd();
      } else {
        this.mapLayerSnowmakingHydrantsRemove();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.cancelPollSnowmakingHydrants();
  }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    mapLayerLiftmaintenanceCablesAdd: function mapLayerLiftmaintenanceCablesAdd() {
      this.initPollLiftmaintenanceCables();
      this.map.addSource('liftmaintenance-cables-source', {
        type: 'geojson',
        data: this.computedLiftmaintenanceCablesGeoJson
      });

      this.map.addLayer({
        id: 'liftmaintenance-cables',
        type: 'line',
        source: 'liftmaintenance-cables-source',
        paint: {
          'line-color': 'Orange',
          'line-width': 3
        },
        layout: {
          'visibility': 'visible',
          'line-join': 'round',
          'line-cap': 'round'
        }
      });
    },
    mapLayerLiftmaintenanceCablesRemove: function mapLayerLiftmaintenanceCablesRemove() {
      this.cancelPollLiftmaintenanceCables();
      this.map.removeLayer('liftmaintenance-cables');
      this.map.removeLayer('liftmaintenance-cables-label');
      this.map.removeSource('liftmaintenance-cables-source');
    },
    initPollLiftmaintenanceCables: function initPollLiftmaintenanceCables() {
      var _this = this;

      this.$store.dispatch('actionGetGeoJson', {
        url: '/static/lift_cables.geojson',
        dept: 'liftmaintenance',
        layer: 'cables'
      });
      this.pollLiftmaintenanceCablesInterval = setInterval(function () {
        _this.$store.dispatch('actionGetGeoJson', {
          url: '/static/lift_cables.geojson',
          dept: 'liftmaintenance',
          layer: 'cables'
        });
      }, 10000);
    },
    cancelPollLiftmaintenanceCables: function cancelPollLiftmaintenanceCables() {
      this.pollLiftmaintenanceCablesInterval = clearInterval(this.pollLiftmaintenanceCablesInterval);
    }
  },
  computed: {
    computedLiftmaintenanceCablesGeoJson: function computedLiftmaintenanceCablesGeoJson() {
      return this.$store.state.layers.liftmaintenance.mapLayers.cables.geojson;
    },
    computedLiftmaintenanceCablesMapVisibility: function computedLiftmaintenanceCablesMapVisibility() {
      return this.$store.state.layers.liftmaintenance.mapLayers.cables.visibility.mapView;
    }
  },
  watch: {
    '$store.state.layers.liftmaintenance.mapLayers.cables.geojson': {
      handler: function handler(val, oldVal) {
        if (this.computedLiftmaintenanceCablesGeoJson) {
          this.mapLayerLiftmaintenanceCablesRemove();
          this.mapLayerLiftmaintenanceCablesAdd();
        }
      }
    },
    '$store.state.layers.liftmaintenance.mapLayers.cables.visibility.mapView': function $storeStateLayersLiftmaintenanceMapLayersCablesVisibilityMapView(newValue, oldValue) {
      if (newValue) {
        this.mapLayerLiftmaintenanceCablesAdd();
      } else {
        this.mapLayerLiftmaintenanceCablesRemove();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.cancelPollLiftmaintenanceCables();
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('action-button'),_vm._v(" "),_c('div',{attrs:{"id":"map"}}),_vm._v(" "),_c('mapbox',{attrs:{"access-token":"","map-options":{
      style: {
        glyphs: 'https://dvn3ptw8fp74t.cloudfront.net/{fontstack}/{range}.pbf',
        version: 8,
        sources: {
          'osm-tiles': {
            type: 'raster',
            tiles: [
            'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png',
            'https://b.tile.openstreetmap.org/{z}/{x}/{y}.png'
            ],
            tileSize: 256
          },
          'marker-layer-source': {
            type: 'geojson',
            data: {
                'type': 'FeatureCollection',
                'features': [{
                    'type': 'Feature',
                    'properties': {},
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -76.53063297271729,
                            39.18174077994108
                        ]
                    }
                }]
            }
          }
        },
        layers: [{
          id: 'osm-tiles',
          type: 'raster',
          source: 'osm-tiles',
          minzoom: 0,
          maxzoom: 22
        },{
          id: 'marker-layer-bottom',
          type: 'circle',
          source: 'marker-layer-source'
        },{
          id: 'marker-layer-polygons',
          type: 'circle',
          source: 'marker-layer-source'
        },{
          id: 'marker-layer-labels',
          type: 'circle',
          source: 'marker-layer-source'
        }]
      },
      center: [-122.937613, 50.099706],
      zoom: 12,
      bearing: 150
    },"geolocate-control":{
      show: true, 
      position: 'top-right'
    }},on:{"map-load":_vm.mapLoaded,"map-init":_vm.mapInitialized}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 50 */,
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persistedstate__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);






__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

// State storage and map layer defaults
var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  plugins: [Object(__WEBPACK_IMPORTED_MODULE_3_vuex_persistedstate__["a" /* default */])()],
  state: {
    toggle: {
      imagry: {
        summer_2014_40cm: false
      },
      signshop: {
        signage: false
      },
      dialog: {
        help: false,
        legal: false,
        login: false,
        add: {
          point: false
        }
      }
    },
    dialogs: {
      ui: {
        dialogHelp: false,
        dialogLegal: false,
        dialogLogin: false,
        dialogChangePassword: false
      },
      addGeometry: {
        dialogSelectPointLayer: false,
        dialogSelectLineLayer: false,
        dialogSelectPolygonLayer: false
      }
    },
    layers: {
      snowmaking: {
        id: 0,
        name: 'snowmaking',
        deptTitle: 'Snowmaking',
        mapLayers: {
          hydrants: {
            name: 'hydrants',
            id: 1,
            layerTitle: 'Hydrants',
            geojson: [],
            visibility: {
              mapView: false,
              listView: false
            },
            type: 'Point',
            isEditable: true,
            components: {
              list: 'components/snowmaking/hydrants/list.vue',
              single: 'components/snowmaking/hydrants/single.vue',
              edit: 'components/snowmaking/hydrants/edit.vue'
            },
            mixin: 'mixins/snowmaking/hydrants/mixin.js',
            apiMethodUrl: {
              readAll: 'https://api.alchemymapping.com/wb/snowmaking/hydrants',
              readSingle: 'https://api.alchemymapping.com/wb/snowmaking/hydrants/:id',
              create: 'https://api.alchemymapping.com/wb/snowmaking/hydrants',
              update: 'https://api.alchemymapping.com/wb/snowmaking/hydrants/:id',
              delete: 'https://api.alchemymapping.com/wb/snowmaking/hydrants/:id'
            }
          }
        }
      },
      liftmaintenance: {
        id: 2,
        name: 'liftmaintenance',
        deptTitle: 'Lift Maintenance',
        mapLayers: {
          cables: {
            name: 'cables',
            id: 3,
            layerTitle: 'Lift Cables',
            geojson: [],
            visibility: {
              mapView: false,
              listView: false
            },
            type: 'LineString',
            isEditable: false,
            components: {
              list: 'components/liftmaintenance/cables/list.vue',
              single: 'components/liftmaintenance/cables/single.vue',
              edit: 'components/liftmaintenance/cables/edit.vue'
            },
            mixin: 'mixins/liftmaintenance/cables/mixin.js',
            apiMethodUrl: {
              readAll: 'https://api.alchemymapping.com/wb/liftmaintenance/cables',
              readSingle: 'https://api.alchemymapping.com/wb/liftmaintenance/cables/:id',
              create: 'https://api.alchemymapping.com/wb/liftmaintenance/cables',
              update: 'https://api.alchemymapping.com/wb/liftmaintenance/cables/:id',
              delete: 'https://api.alchemymapping.com/wb/liftmaintenance/cables/:id'
            }
          }
        }
      }
    },
    general: {
      title: 'GeoWB',
      copyrightNotice: 'The GeoWB website, application and back end infrastructure is copyright 2018 by Mike Hamilton and Alchemy Mapping Solutions, Inc.',
      copyrightNoticeShort: '© 2018 Alchemy Mapping Solutions/Mike Hamilton',
      copyrightData: 'All GIS data is by Heather Dufty and is copyright 2016-2018 Whistler Blackcomb.'
    },
    geojson: {
      snowmaking: {
        hydrants: []
      },
      liftmaintenance: {
        cables: []
      }
    }
  },
  actions: {
    actionGetGeoJson: function actionGetGeoJson(_ref, layerData) {
      var commit = _ref.commit;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(layerData.url).then(function (response) {
        commit('mutationGetGeoJson', {
          data: response.data,
          dept: layerData.dept,
          layer: layerData.layer
        });
      }, function (err) {
        console.log(err);
      });
    }
  },
  mutations: {
    mutationGetGeoJson: function mutationGetGeoJson(state, _ref2) {
      var data = _ref2.data,
          dept = _ref2.dept,
          layer = _ref2.layer;

      function jsonEqual(a, b) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(a) === __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(b);
      }
      if (!jsonEqual(state.layers[dept].mapLayers[layer].geojson, data)) {
        state.layers[dept].mapLayers[layer].geojson = data;
      }
    },
    mutationDialogUi: function mutationDialogUi(state, payload) {
      state.dialogs.ui[payload.dialog] = !state.dialogs.ui[payload.dialog];
    },
    toggleSummer2014: function toggleSummer2014(state) {
      state.toggle.imagry.summer_2014_40cm = !state.toggle.imagry.summer_2014_40cm;
    },
    toggleDialogHelp: function toggleDialogHelp(state) {
      state.toggle.dialog.help = !state.toggle.dialog.help;
    },
    toggleDialogLegal: function toggleDialogLegal(state) {
      state.toggle.dialog.legal = !state.toggle.dialog.legal;
    },
    toggleDialogLogin: function toggleDialogLogin(state) {
      state.toggle.dialog.login = !state.toggle.dialog.login;
    },
    toggleDialogAddPoint: function toggleDialogAddPoint(state) {
      state.toggle.dialog.add.point = !state.toggle.dialog.add.point;
    },
    toggleDataSnowmakingHydrants: function toggleDataSnowmakingHydrants(state) {
      state.toggle.data.snowmaking.hydrants = !state.toggle.data.snowmaking.hydrants;
    },
    toggleDataLiftmaintenanceCables: function toggleDataLiftmaintenanceCables(state) {
      state.toggle.data.liftmaintenance.cables = !state.toggle.data.liftmaintenance.cables;
    },
    mutationMapLayer: function mutationMapLayer(state, payload) {
      state.layers[payload.dept].mapLayers[payload.layer].visibility.mapView = !state.layers[payload.dept].mapLayers[payload.layer].visibility.mapView;
    },
    mutationListLayer: function mutationListLayer(state, payload) {
      state.layers[payload.dept].mapLayers[payload.layer].visibility.listView = !state.layers[payload.dept].mapLayers[payload.layer].visibility.listView;
    }
  }
});

/***/ })
],[21]);


// WEBPACK FOOTER //
// static/js/app.66ac86687bf5deac644a.js